import { render, staticRenderFns } from "./TaskWorkflowCreated.vue?vue&type=template&id=6c29a44e&scoped=true"
import script from "./TaskWorkflowCreated.vue?vue&type=script&lang=js"
export * from "./TaskWorkflowCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c29a44e",
  null
  
)

export default component.exports